/**
 * CRM page — Connection tab (DNKADM-0499). One read-only card ({@link SummaryCard}, no Edit:
 * there is nothing to change here): connected or not, the account (location) name, and the
 * one sentence that says what the connection means.
 */
import { useCallback } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { useResource } from '@/hooks/useResource';
import { getCrmOverview } from '@/api/crm';
import { ScreenError } from '@/components/ScreenError';
import { SummaryCard, SummaryRow } from '@/features/services/SummaryCard';
import { CRM_DISPLAY_NAME } from '@/utils/whitelabel';

export function CrmConnectionTab() {
  const overview = useResource(useCallback(() => getCrmOverview(), []), []);

  if (overview.status === 'loading' && overview.data === null) {
    return (
      <Skeleton
        variant="rounded"
        height={140}
        role="status"
        aria-label="Loading the connection"
        sx={{ borderRadius: 3, maxWidth: 720 }}
      />
    );
  }
  if (overview.status === 'error' || overview.data === null) {
    return <ScreenError error={overview.error} what="the connection" onRetry={overview.refetch} />;
  }

  const { connection } = overview.data;
  return (
    <SummaryCard title="Connection" onEdit={() => undefined} noEdit>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
        Every member in Dink is a contact in your {CRM_DISPLAY_NAME}.
      </Typography>
      <SummaryRow label="Status" value={connection.connected ? 'Connected' : 'Not connected'} />
      <SummaryRow label="Account" value={connection.locationName ?? '—'} last />
    </SummaryCard>
  );
}
